var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6143 5.73608V16.3521L19.6303 25.1001C18.2595 26.0426 16.6863 26.6497 15.0377 26.8725C13.3891 27.0952 11.7113 26.9275 10.1394 26.3827C8.5676 25.8379 7.1458 24.9313 5.98869 23.7361C4.83159 22.5409 3.97158 21.0904 3.47801 19.5018C2.98444 17.9131 2.87113 16.2307 3.14723 14.5902C3.42333 12.9497 4.08112 11.397 5.06752 10.0574C6.05392 8.71783 7.34133 7.62882 8.82593 6.87819C10.3105 6.12756 11.9507 5.73635 13.6143 5.73608Z",
    fill: "#228711"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7434 12.616V2.00001C17.2454 1.99607 19.6677 2.87981 21.5794 4.49402L14.7434 12.616Z",
    fill: "#9AFFA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3072 10.257C23.1429 11.4447 23.7244 12.7921 24.0152 14.215L13.6152 16.353L20.4522 8.23096C21.1555 8.82336 21.779 9.50436 22.3072 10.257Z",
    fill: "#D0FFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6152 16.3521L24.0152 14.2141C24.4332 16.2588 24.2404 18.3812 23.4608 20.317C22.6813 22.2529 21.3495 23.9167 19.6312 25.1011L13.6152 16.3521Z",
    fill: "#3CC430"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.f8a8ba2d32b928f1a177fb005fd327fc.svg";
export { ForwardRef as ReactComponent };